module.exports = __webpack_public_path__ + "static/media/newsletter.c69b92fc.svg";